<template>
    <div>



        <div style="display: flex;justify-content: center;">

            <div style="width: 1200px;padding-top: 50px;">
                <div style="text-align: center;">
                    <img src="/static/img/zhaoqing/LOGO-肇庆市.png" alt="">
                    <p id="index-title">肇庆市科研设施与仪器开放共享服务平台</p>
                    <div style="margin-top: 25px;">
                        <el-input class="serach-input"
                                  v-model="searchText"
                                  placeholder="请输入想浏览的设施与设备"
                                  clearable
                                  style="width:80%;height:60px;line-height: 60px;font-size: 22px;border: 2px solid #1EB38A;">
                            <template #prepend>

                                <el-select
                                    v-model="typeCode"
                                           placeholder="请选择仪器分类"
                                           clearable
                                           style="width: 240px;height:100%;line-height: 100%;font-size: 18px;border-right: 2px solid #1EB38A;">
                                    <el-option
                                         v-for="(item,index) in cascaderOptions"
                                         :key="index"
                                        :label="item.nodeName"
                                        :value="item.treeCode"
                                    />
                                </el-select>

                            </template>
                            <template #append>
                                <el-button :icon="Search"  style="background-color: #1EB38A;color: white;border-radius: 0px;height: 100%;width:100px;" @click="toSearch"/>
                            </template>
                        </el-input>
                    </div>
                </div>


                <div class="introduce-div">
                    <div style="display: flex;justify-content: space-between;width:100%;">
                        <div class="introduce-main-instrument" @click="toInstrument">
                            <img src="/static/img/zhaoqing/仪器填报.svg" style="width: 50px;height: 50px;">
                            <span style="padding-left: 10px;">
                                <span class="introduce-title">仪器填报</span><br/>
                                <span class="introduce-desc">
                                    请点击仪器填报
                                </span>
                            </span>
                        </div>
                        <div class="introduce-main"  @click="toLib">
                            <img src="/static/img/zhaoqing/仪器总数.svg" style="width: 50px;height: 50px;">
                            <span style="padding-left: 10px;">
                                <span class="introduce-title">总数：{{ countData.countNumber }}</span><br/>
                                <span class="introduce-desc">
                                    肇庆数：{{ zhaoqingCountData.countNumber }}
                                </span>
                            </span>
                        </div>
                        <div class="introduce-main" @click="toHelp">
                            <img src="/static/img/zhaoqing/仪器价值.svg" style="width: 50px;height: 50px;">
                            <span style="padding-left: 10px;">
                                <span class="introduce-title">
                                     总价值：{{ CommonUtil.accDiv(countData.worthCount, 10000,2)}}（亿元）
                                </span><br/>
                                <span class="introduce-desc">
                                     肇庆总价值：{{ CommonUtil.accDiv(zhaoqingCountData.worthCount, 10000,2)}}（亿元）
                                </span>
                            </span>
                        </div>
                        <div class="introduce-main" @click="toHelp">
                            <img src="/static/img/zhaoqing/使用机时.svg" style="width: 50px;height: 50px;">
                            <span style="padding-left: 10px;">
                                <span class="introduce-title">
                                    {{ CommonUtil.accDiv(countData.serviceMachineCount, countData.countNumber,2)}}

<!--                                    {{ countData.serviceMachineCount }}-->

                                </span><br/>
                                <span class="introduce-desc">
                                    年平均有效机时（小时）
                                </span>
                            </span>
                        </div>
                    </div>


                </div>


                <div>
                    <div style="margin-top: 50px;">
                        <h2 style="text-align: center;">预约仪器</h2>
                        <div style="text-align: center;">
                            <img src="/static/img/zhaoqing/title短图标.svg" alt="">
                        </div>
                    </div>
                    <div style="display: flex;height: 610px;margin-top: 50px;">
                        <div style="width: 20%;">
                            <div class="collapse-type-box">
                                <el-collapse class="collapse-content" v-model="activeName" accordion>


                                    <el-collapse-item name="1" style="background-color: transparent;">
                                        <template #title>
                                            <span class="collapse-title">所属分类</span>
                                        </template>
                                        <div>
                                            <li v-for="(item,index) in cascaderOptions" :key="index" class="collapse-list" @click="typeClickToSearch(item)">{{ item.nodeName }}</li>

                                        </div>
                                    </el-collapse-item>
                                    <el-collapse-item name="2" style="background-color: transparent;">
                                        <template #title>
                                            <span class="collapse-title">产业领域</span>
                                        </template>
                                        <div>
                                            <li class="collapse-list"
                                                v-for="(item,index) in resInstrumentZhuhaiIndustrialSectorList"
                                                :key="index"
                                                @click="sectorClickToSearch(item)"
                                            >{{ item.dictName }}</li>

                                        </div>
                                    </el-collapse-item>
                                </el-collapse>
                            </div>


                        </div>
                        <div style="width: 80%;height: 100%;" v-loading="instrumentLoad">

                            <el-row style="height: 100%;">
                                <el-col :span="6" v-for="(item,index) in instrumentList" :key="index" style="height: 50%;">
                                    <div style="padding-left: 10px;height: 100%;">
                                        <div class="instrument-content" :key="index" @click="gotoDetail(item)">
                                            <div style="width: 100%;height: calc(100% - 97px);">
                                                <el-image :src="$getImage(item.image)"  style="width: 100%;height:100%;">
                                                    <template #error>
                                                        <img style="width: 100%;height:100%;" src="/static/img/zhuhai/仪器图片.png" alt="">
                                                    </template>
                                                </el-image>
                                            </div>


                                            <div class="instrument-text-box">
                                                <p class="instrument-name">{{ item.cname }}</p>
                                                <p class="instrument-text">型号：{{ item.instrVersion }}</p>
                                                <p class="instrument-text">分类：{{ item.catalogName1 }}</p>
                                                <p class="instrument-text"><img src="/static/img/zhuhai/地点浮标.svg" alt="">{{item.cityName}}{{ item.address }}</p>
                                            </div>
                                        </div>
                                    </div>

                                </el-col>
                            </el-row>




                        </div>


                    </div>
                </div>

                <div style="margin-top: 50px;display: flex;justify-content: space-between;">
                    <div style="width: 49%;">
                        <div>
                            <h2>科技服务</h2>
                            <div>
                                <img src="/static/img/zhaoqing/title短图标.svg" alt="">
                            </div>
                        </div>
                        <div class="technology-service">
                            <div class="technology-service-box" style="border-right: 1px solid #D8D8D8;" @click="gotoInstitution('WEB_ZHAOQING_TECHNOLOGY_POLICY')">
                                <img style="width: 58px;height: 58px;" src="/static/img/zhaoqing/科技政策.svg" alt="">
                                <span class="technology-service-text">科技政策</span>
                            </div>
                            <div class="technology-service-box" style="border-bottom: 1px solid #D8D8D8;" @click="gotoInstitution('WEB_ZHAOQING_INFORMATION_RELEASE')">
                                <img style="width: 58px;height: 58px;" src="/static/img/zhaoqing/信息发布.svg" alt="">
                                <span class="technology-service-text">信息发布</span>
                            </div>
                            <div class="technology-service-box"  style="border-top: 1px solid #D8D8D8;" @click="toInstrument()">
                                <img style="width: 58px;height: 58px;" src="/static/img/zhaoqing/设备共享.svg" alt="">
                                <span class="technology-service-text">设备共享</span>
                            </div>
                            <div class="technology-service-box"  style="border-left: 1px solid #D8D8D8;" @click="gotoFillingGuide()">
                                <img style="width: 58px;height: 58px;" src="/static/img/zhaoqing/填报指南.svg" alt="">
                                <span class="technology-service-text">填报指南</span>
                            </div>
                        </div>

                    </div>
                    <div style="width: 49%;">
                        <h2>实验室与平台基地</h2>
                        <div>
                            <img src="/static/img/zhaoqing/title长图标.svg" alt="">
                        </div>
                        <div class="platform-service">
                            <div class="platform-box"
                                 @click="gotoPlatformList(item)"
                                 v-for="(item,index) in platformTypeList.slice(0,4)"
                                 :key="index">
                                <div class="platform-service-number">{{ item.platformNum }}</div>
                                <div class="platform-service-text">{{ item.typeName }}（家）</div>
                            </div>
                        </div>
                    </div>

                </div>


            </div>


        </div>
        <div class="foundation-facility">
            <div style="width: 1200px;">


                <h2 style="margin-top: 40px;">公共服务平台</h2>
                <div>
                    <img src="/static/img/zhaoqing/公共服务平台图标.svg" alt="">
                </div>

                <div style="margin-top: 20px;position: relative;">
                    <el-carousel ref="carouselRef" height="250px" :autoplay="false" indicator-position="none"
                                 :motion-blur="true" arrow="never" v-loading="zoneLoading">
                        <el-carousel-item v-for="(groupIndex, i) in Math.ceil(zoneList.length / 3)"
                                          :key="groupIndex">
                            <div style="display: flex;justify-content: space-between;height: 100%;">
                                <div class="foundation-facility-box"
                                     @click="gotoZoneDetail(item)"
                                     v-for="(item, itemIndex) in zoneList.slice((groupIndex - 1) * 3,Math.min(groupIndex * 3, zoneList.length))"
                                     :key="item.dictVal || itemIndex"
                                >
                                    <img style="width: 100%;height:80%;border-radius: 10px;" :src="$getImage(item.imgs ? item.imgs.split(',')[0] : '')" alt="">
                                    <div style="height: 20%;">{{ item.zoneName }}</div>
                                </div>
                            </div>


                        </el-carousel-item>

                    </el-carousel>
                    <img class="img-button" style="left: -75px;" src="/static/img/zhaoqing/left.svg" alt="" @click="zonePrev">

                    <img class="img-button" style="right: -75px;" src="/static/img/zhaoqing/right.svg" alt=""  @click="zoneNext">



                </div>

            </div>


        </div>
    </div>
</template>

<script setup >


import {ref, toRefs, reactive, getCurrentInstance, onMounted} from 'vue'
import { Search } from '@element-plus/icons-vue'
import router from "@/router";
import CommonUtil from "@/utils/common";
import { ElMessage } from 'element-plus'

const {proxy} = getCurrentInstance();
const bannerList = ref([]);
const newsItems = ref([]);

const bannerLoading = ref(false)
const newsLoading = ref(false)

const searchText = ref('')
const typeCode = ref('')

const activeName = ref('1')



function fetchBannerList() { //读取滚动大图
    bannerLoading.value = true;
    var url = "/core/cms/a/webAdInfo/list?noPage=1&typeCode=WEB_HOME_ROLL_IMG";

    proxy.$http.post(url).then(res => {
        bannerLoading.value = false
        if (res.data.state == 0) {
            var list = [];
            for (let i = 0; i < res.data.result.length; i++) {
                const imageLink = proxy.$getImage(res.data.result[i].imgCode);
                list.push({src: imageLink, url: res.data.result[i].linkUrl});
            }

            bannerList.value = list;
        }
    }).catch(err => {
        bannerLoading.value = false
    })
}
const tempItems = ref([]);
async function getArticleList(typeCode, newsNum){   //获取文章列表
    newsLoading.value = true
    const url = '/core/cms/a/articleContent/list?limit=' + newsNum + '&typeCode=' + typeCode + '&apprStatus=1,99&publishStatus=1&timeField=publish_time';
    await proxy.$http.post(url).then(res=>{
        // console.log(res)
        newsLoading.value = false
        if(res.data.state == 0){
            tempItems.value = res.data.result;

            // newsItems.value.push(tempItems.value);

            // console.log(tempItems);
        }
    }).catch(err=>{
        newsLoading.value = false
    })
}




const toSearch = ()=>{

    let param = {
        searchText: searchText.value,
        typeCode: typeCode.value
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingResRetrieve', query: param})

}

const toInstrument = async () => {


    var userInfo = proxy.$store.state.userInfo;
    if (userInfo && userInfo.userCode) {
        let isPlatformAdmin = await CommonUtil.isPlatformAdmin();

        if (isPlatformAdmin) {
            let goPageurl = proxy.indexUrl + "/zhaoqing/zhaoqinguser/platformPages?iframeUrl=/gdsti2v/resource/resDataFormInstrument/list";
            window.open(goPageurl);
        } else {
            ElMessage.error('您没有权限，只有平台负责人才能进行汇交。');
        }
    } else {
        ElMessage.error("请先登录");
    }

}

const gotoInstitution = (id)=>{

    let param = {
        id: id,
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingInstitution', query: param})
}

const gotoFillingGuide = ()=>{
    proxy.$router.push({path: '/zhaoqing/zhaoqingFillingGuide'})
}

const typeClickToSearch = (item)=>{
    console.log(item)
    let param = {
        typeCode: item.treeCode
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingResRetrieve', query: param})

}

const sectorClickToSearch = (item)=>{
    console.log(item)
    let param = {
        industrialSector: item.dictVal
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingResRetrieve', query: param})

}

const cascaderOptions = ref([])
const typeLoading = ref(false)

//查询仪器目录
const getCatalogTree = () => {
    typeLoading.value = true;
    proxy.$http.post('/gdsti2/web/a/webResource/catalogTree.do?isOpen=ALL&catalogType=INSTRUMENT_DATA').then(res => {
        if (res.data.state === 0) {
            cascaderOptions.value = res.data.result;
        }
        typeLoading.value = false;
    }).catch(err => {
        typeLoading.value = false;
    });
}

const platformTypeList = ref([])
const getPlatformType = () => {
    console.log('getPlatformType调用')
    proxy.$http.post('/gdsti2/web/a/webLab/platformCount').then(res => {
        if (res.data.state === 0) {
            platformTypeList.value = res.data.result;
        }
    }).catch(err => {
    });
}


const gotoPlatformList = (item)=>{
    console.log(item)
    let param = {
        laboratoryTypeId: item.typeCode
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingPlatform', query: param})

}


const countData = ref({})
const getCountData = () => {
    proxy.$http.post('/gdsti2/web/a/webResource/instrumentDataCount').then(res => {
        if (res.data.state === 0) {
            countData.value = res.data.result;
        }
    }).catch(err => {
    });
}

//查询肇庆城市的仪器数据
const zhaoqingCountData = ref({})
const getZhaoqingCountData = () => {
    let param = {
        city: '441200'
    }
    proxy.$http.post('/gdsti2/web/a/webResource/instrumentDataCount',param).then(res => {
        if (res.data.state === 0) {
            zhaoqingCountData.value = res.data.result;
        }
    }).catch(err => {
    });
}

const instrumentList = ref([])
const instrumentLoad = ref(false)
const getInstrument = () => {
    instrumentLoad.value = true;
    let param = {
        type: 'new',
        noPage: 1,
        limit: 8,
    }
    proxy.$http.post('/gdsti2/resource/a/resDataFormInstrument/webList',param).then(res => {
        if (res.data.state === 0) {
            instrumentList.value = res.data.result;
        }
        instrumentLoad.value = false;
    }).catch(err => {
        instrumentLoad.value = false;
    });
}

const gotoDetail = (item) => {
    let param = {
        id: item.id,
        catalogType: item.catalogType
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingInstrumentInfo', query: param})
}

const gotoZoneDetail = (item) => {
    let param = {
        id: item.id,
    }
    proxy.$router.push({path: '/zhaoqing/zhaoqingIndustryDetail', query: param})
}

//产业领域
const resInstrumentZhuhaiIndustrialSectorList = ref([]);


const zoneList = ref([])
const zoneLoading = ref(false);
const getZoneList = () => {
    zoneLoading.value = true;
    let param = {
        noPage: 1,
    }
    proxy.$http.post('/gdsti2/web/a/webZone/list',param).then(res => {
        if (res.data.state === 0) {
            zoneList.value = res.data.result;
        }
        zoneLoading.value = false;
    }).catch(err => {
        zoneLoading.value = false;
    });
}

const carouselRef = ref(null);
const zonePrev = () => {
    carouselRef.value.prev();
}
const zoneNext = () => {
    carouselRef.value.next();
}


onMounted(async () => {
    //显示BAR条内容
    fetchBannerList();



    getCatalogTree();
    getPlatformType();
    getCountData();
    getZhaoqingCountData();
    getInstrument();

    resInstrumentZhuhaiIndustrialSectorList.value = await CommonUtil.loadDataDictList('RES_INSTRUMENT_ZHUHAI_INDUSTRIAL_SECTOR')

    getZoneList();
});


</script>

<style lang="less" scoped>

#index-title{


    font-family: DingTalk JinBuTi;
    font-size: 36px;
    font-weight: normal;
    line-height: normal;
    letter-spacing: 0em;

    //font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #FFFFFF;

    text-shadow: 0px 2px 3px #0037A5;

}
/deep/ .el-select__wrapper{
    height: 100%;
}


.introduce-div {
    margin-top: 70px;
    width: 100%;
    display: flex;
    justify-content: center;
    opacity: 1;
}

.introduce-main, .introduce-main-instrument {
    background: linear-gradient(180deg, #F4F3F8 0%, rgba(255, 255, 255, 0) 97%);
    border-radius: 8px;
    display: flex;

    box-shadow: 0px 2px 6px 0px #BDD7F9;
    border: 5px solid white;
    padding: 10px 10px;
    opacity: 1;
    background-color: white;
    width: 21%;
}


//.introduce-main-instrument {
//    background: linear-gradient(180deg, #F4F3F8 0%, rgba(255, 255, 255, 0) 97%);
//    border-radius: 8px;
//    display: flex;
//
//    box-shadow: 0px 2px 6px 0px #BDD7F9;
//    border: 5px solid white;
//    padding: 5px 10px;
//    opacity: 1;
//    background-color: white;
//    width: 22%;
//}

.introduce-main-instrument:hover{
    cursor: pointer;
}

.introduce-desc{
    font-size: 14px;
    font-weight: normal;
    line-height: 29px;
    letter-spacing: 0px;
    color: #8A8A8A;
}
.collapse-content{
    border:none;
    padding: 5px 15px;
}
/deep/ .collapse-content .el-collapse-item__header,
/deep/ .collapse-content  .el-collapse-item__wrap,
/deep/ .collapse-content  .el-collapse-item__content
{
    background-color: transparent !important;
    color: white;
    border: none;
    padding-bottom: 0px;
}
.collapse-title{
    font-size: 22px;
    font-weight: bold;
    line-height: normal;
    text-align: center;
    letter-spacing: 0px;
}
.collapse-list{
    margin-top: 15px;
}
.collapse-list:hover{
    cursor:pointer;
}
.collapse-type-box{
    height: 100%;
    box-sizing: border-box;
    /* 内容溢出时自动显示滚动条 */
    overflow: auto;
    background: linear-gradient(159deg, #1EB38A -5%, #6BE2C0 25%, #40E1B4 49%, #6BE2C0 69%, #1EB38A 92%);
    //background: linear-gradient(159deg, #1B66FC -5%, #7EA8FA 25%, #94B7FA 49%, #7EA8FA 68%, #1B66FC 100%);
    scrollbar-color: white transparent;
    scrollbar-width: thin;
}
.instrument-content{
    height: 100%;
    //display: flex;
    //flex-wrap: wrap;
}
.instrument-content:hover{
    cursor: pointer;
}
.instrument-text-box{
    background: #E8F6F2;
    width: 100%;
    height: 97px;
    //padding: 10px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}
.instrument-name{
    font-family: Source Han Sans;
    padding-bottom: 5px;
    color: #1EB38A;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0px;
    width: 90%;

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* 显示省略号 */
}
.instrument-text{
    font-family: Source Han Sans;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* 显示省略号 */
    color: #3D3D3D;
    font-size: 12px;
    font-weight: normal;
    line-height: 20px;
    letter-spacing: 0px;
    width: 90%;
}
.technology-service{
    height: 320px;
    background-color: white;
    border-radius: 2px;
    display: flex;
    flex-wrap: wrap;
}

.technology-service-box{
    width: 50%;
    height:50%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.technology-service-box:hover{
    cursor: pointer;
}
.technology-service-text{
    font-family: Source Han Sans;
    margin-top: 10px;
    font-size: 26px;
    font-weight: 500;
    line-height: 20px;
    letter-spacing: 0px;
    color: #3D3D3D;
}
.platform-service{
    height: 320px;
    background-color: white;
    border-radius: 2px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    align-items: center;
}
.platform-box{
    background-color: #E8F6F2;
    width: 45%;
    height: 43%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.platform-box:hover{
    cursor: pointer;
}

.platform-service-number{
    font-family: Microsoft YaHei;
    font-size: 44px;
    font-weight: bold;
    line-height: normal;
    text-align: center;
    letter-spacing: 0.55px;
    color: #1EB38A;
}
.platform-service-text{
    font-family: Microsoft YaHei;
    font-size: 18px;
    font-weight: normal;
    line-height: normal;
    text-align: center;
    letter-spacing: 0.55px;
    color: #1EB38A;
}
.foundation-facility{
    height: 480px;
    background-color: white;
    display: flex;
    justify-content: center;
    margin-top: 40px;
    padding-bottom: 50px;
}

.foundation-facility-box{
    width: 30%;
    height: 100%;
    text-align: center;
}
.foundation-facility-box:hover{
    cursor: pointer;
}
.img-button:hover{
    cursor: pointer;
}
.img-button{
    height: 50px;
    width: 50px;
    position: absolute;
    top: calc(50% - 25px);
}
</style>

